import React from 'react';
import { createRoot } from 'react-dom/client';
import { Widget } from './Widget';
import { getConfigFromScript } from './config';

/**
 * Punto de entrada del script embebido.
 * Se ejecuta al cargar: <script src="https://.../kenbun.iife.js" data-site-id="TU_CODIGO"></script>
 */
function init() {
  const config = getConfigFromScript();
  if (!config?.siteId) {
    if (typeof console !== 'undefined') {
      console.warn('[Kenbun] No se encontró data-site-id en el script. Añade: <script ... data-site-id="TU_CODIGO">');
    }
    return;
  }

  const rootId = 'kenbun-root';
  let rootEl = document.getElementById(rootId);
  if (!rootEl) {
    rootEl = document.createElement('div');
    rootEl.id = rootId;
    rootEl.setAttribute('aria-hidden', 'true');
    rootEl.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:2147483647;';
    document.body.appendChild(rootEl);
  }

  const root = createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <Widget config={config} />
    </React.StrictMode>
  );
}

if (typeof document !== 'undefined' && document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
